exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".commentEditor-daf8d{padding:12px 10px}.commentEditor-daf8d div{margin:0}", ""]);

// Exports
exports.locals = {
	"commentEditor": "commentEditor-daf8d"
};